var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSqaureDashboard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M24.0002 59.1667H40.0002C53.3335 59.1667 58.6668 53.8333 58.6668 40.5V24.5C58.6668 11.1667 53.3335 5.83334 40.0002 5.83334H24.0002C10.6668 5.83334 5.3335 11.1667 5.3335 24.5V40.5C5.3335 53.8333 10.6668 59.1667 24.0002 59.1667Z",
    fill: "#7E54C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2397 20.98H39.5464V32.3133",
    stroke: "#7E54C5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5465 20.98L24.4531 36.0733",
    stroke: "#7E54C5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 44.5266C26.3733 47.9933 37.6267 47.9933 48 44.5266",
    stroke: "#7E54C5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSqaureDashboard);
export default __webpack_public_path__ + "static/media/sqaure-dashboard.8b6edf5e629c98fdc7b1cd453a31df10.svg";
export { ForwardRef as ReactComponent };